var _rect, _path, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceContent0103(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#FABB00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7501 18.25H41.2499C42.6307 18.25 43.75 19.3693 43.75 20.7501V40.2499C43.75 41.6307 42.6307 42.75 41.2499 42.75H18.7501C17.3693 42.75 16.25 41.6307 16.25 40.2499V20.7501C16.25 19.3693 17.3693 18.25 18.7501 18.25Z",
    stroke: "#1B1C1E",
    strokeWidth: 2.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.0991,
    y1: 15.75,
    x2: 23.0991,
    y2: 20.25,
    stroke: "#1B1C1E",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 37.0991,
    y1: 15.75,
    x2: 37.0991,
    y2: 20.25,
    stroke: "#1B1C1E",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16.875,
    y1: 26.4297,
    x2: 45,
    y2: 26.4297,
    stroke: "#1B1C1E",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceContent0103);
export default __webpack_public_path__ + "static/media/service-content01-03.06860024c98c956a4ba1ba8560b27978.svg";
export { ForwardRef as ReactComponent };